import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared.module';
import { PatientInfoWindowComponent } from './patient-info-window/patient-info-window.component';

@NgModule({
  declarations: [PatientInfoWindowComponent],
  imports: [SharedModule],
  exports: [PatientInfoWindowComponent]
})
export class PatientInfoWindowSharedModule { }
